__turbopack_context__.v({
  "benefitCard": "home-module__06co2W__benefitCard",
  "benefitDescription": "home-module__06co2W__benefitDescription",
  "benefitIcon": "home-module__06co2W__benefitIcon",
  "benefitTitle": "home-module__06co2W__benefitTitle",
  "benefitsGrid": "home-module__06co2W__benefitsGrid",
  "blogPreviewCta": "home-module__06co2W__blogPreviewCta",
  "blogPreviewCtaLink": "home-module__06co2W__blogPreviewCtaLink",
  "blogPreviewLink": "home-module__06co2W__blogPreviewLink",
  "blogPreviewList": "home-module__06co2W__blogPreviewList",
  "blogPreviewSection": "home-module__06co2W__blogPreviewSection",
  "cardDescription": "home-module__06co2W__cardDescription",
  "cardIcon": "home-module__06co2W__cardIcon",
  "cardTitle": "home-module__06co2W__cardTitle",
  "ctaButton": "home-module__06co2W__ctaButton",
  "featuredCard": "home-module__06co2W__featuredCard",
  "featuredGrid": "home-module__06co2W__featuredGrid",
  "featuredSection": "home-module__06co2W__featuredSection",
  "heroCTA": "home-module__06co2W__heroCTA",
  "heroContent": "home-module__06co2W__heroContent",
  "heroDescription": "home-module__06co2W__heroDescription",
  "heroSection": "home-module__06co2W__heroSection",
  "heroSubtitle": "home-module__06co2W__heroSubtitle",
  "heroTitle": "home-module__06co2W__heroTitle",
  "howItWorksSection": "home-module__06co2W__howItWorksSection",
  "iconBox": "home-module__06co2W__iconBox",
  "sectionDescription": "home-module__06co2W__sectionDescription",
  "sectionTitle": "home-module__06co2W__sectionTitle",
  "stepCard": "home-module__06co2W__stepCard",
  "stepDescription": "home-module__06co2W__stepDescription",
  "stepNumber": "home-module__06co2W__stepNumber",
  "stepTitle": "home-module__06co2W__stepTitle",
  "stepsContainer": "home-module__06co2W__stepsContainer",
  "whyChooseSection": "home-module__06co2W__whyChooseSection",
});
